module.exports = __webpack_public_path__ + "img/dashboard.5ea9852a.svg";